const scene3D = {}
const defaultState = {

}

export default scene3D